import React, { useState, useEffect } from 'react';

const CountdownTimer: React.FC = () => {
    const [timeLeft, setTimeLeft] = useState<string>('');

    useEffect(() => {
        const updateTimer = () => {
            const now = new Date();

            // Définir l'heure cible à 8h du matin, heure de Paris
            const targetDate = new Date(now);
            targetDate.setHours(8, 0, 0, 0);

            // Utiliser l'API Intl pour ajuster au fuseau horaire de Paris
            const options: Intl.DateTimeFormatOptions = {
                timeZone: 'Europe/Paris',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false
            };

            const formatter = new Intl.DateTimeFormat([], options);
            const parts = formatter.formatToParts(targetDate);

            const hours = parts.find(part => part.type === 'hour')?.value;
            const minutes = parts.find(part => part.type === 'minute')?.value;

            if (now > targetDate) {
                targetDate.setDate(targetDate.getDate() + 1);
            }

            const difference = targetDate.getTime() - now.getTime();

            if (difference <= 0) {
                targetDate.setDate(targetDate.getDate() + 1);
            } else {
                const hoursLeft = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutesLeft = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
                const secondsLeft = Math.floor((difference % (1000 * 60)) / 1000);

                setTimeLeft(`${hoursLeft.toString().padStart(2, '0')}:${minutesLeft.toString().padStart(2, '0')}:${secondsLeft.toString().padStart(2, '0')}`);
            }
        };

        updateTimer();
        const intervalId = setInterval(updateTimer, 1000);

        return () => clearInterval(intervalId);
    }, []);

    return (
        <div>
            <h1>Reset : {timeLeft}</h1>
        </div>
    );
};

export default CountdownTimer;
